import { Injectable } from '@angular/core';
import AppConstants from '../constants/app.constants';

export type AppearanceTheme = 'system' | 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  init(): AppearanceTheme {
    const theme = this.getStoredTheme();
    this.applyTheme(theme);
    return theme;
  }

  getStoredTheme(): AppearanceTheme {
    const storedTheme = localStorage.getItem(AppConstants.SELECTED_APPEARANCE_THEME);
    const theme = this.normalizeTheme(storedTheme);

    if (!storedTheme) {
      localStorage.setItem(AppConstants.SELECTED_APPEARANCE_THEME, theme);
    }

    return theme;
  }

  setTheme(theme: string): AppearanceTheme {
    const normalizedTheme = this.normalizeTheme(theme);
    localStorage.setItem(AppConstants.SELECTED_APPEARANCE_THEME, normalizedTheme);
    this.applyTheme(normalizedTheme);

    return normalizedTheme;
  }

  applyTheme(theme: AppearanceTheme): void {
    if (typeof document === 'undefined') {
      return;
    }

    const root = document.documentElement;

    if (theme === 'system') {
      root.removeAttribute('data-theme');
      root.style.colorScheme = 'light dark';
      return;
    }

    root.setAttribute('data-theme', theme);
    root.style.colorScheme = theme;
  }

  private normalizeTheme(theme: string | null | undefined): AppearanceTheme {
    if (theme === 'light' || theme === 'dark' || theme === 'system') {
      return theme;
    }

    return AppConstants.DEFAULT_APPEARANCE_THEME as AppearanceTheme;
  }
}

export function initializeThemePreference(): AppearanceTheme {
  const storedTheme = localStorage.getItem(AppConstants.SELECTED_APPEARANCE_THEME);
  const theme = (storedTheme === 'light' || storedTheme === 'dark' || storedTheme === 'system'
    ? storedTheme
    : AppConstants.DEFAULT_APPEARANCE_THEME) as AppearanceTheme;

  if (!storedTheme) {
    localStorage.setItem(AppConstants.SELECTED_APPEARANCE_THEME, theme);
  }

  if (typeof document !== 'undefined') {
    const root = document.documentElement;

    if (theme === 'system') {
      root.removeAttribute('data-theme');
      root.style.colorScheme = 'light dark';
    } else {
      root.setAttribute('data-theme', theme);
      root.style.colorScheme = theme;
    }
  }

  return theme;
}